export default __webpack_public_path__ + "static/media/Fig5.d0431876.jpg";